import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';

/** Dealer list menus (matches NewAIAvatarLayout sidebar). */
export const HEADER_DEALER_MENU_SX: SystemStyleObject<Theme> = {
  '& .MuiPaper-root': {
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
    padding: 0,
  },
};

/** Profile menu panel styling — shared across header dropdowns. */
export const HEADER_DROPDOWN_MENU_SX: SystemStyleObject<Theme> = {
  '& .MuiPaper-root': {
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
    minWidth: '200px',
    padding: '16px',
  },
};

export const HEADER_DROPDOWN_MENU_LIST_SX: SystemStyleObject<Theme> = {
  padding: 0,
};

export const HEADER_DROPDOWN_MENU_BODY_SX: SystemStyleObject<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  padding: 0,
};

/** Profile-like trigger on the dark header bar. */
export const HEADER_DROPDOWN_TRIGGER_SX: SystemStyleObject<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
  padding: '4px 12px 4px 16px',
  minHeight: 40,
  borderRadius: '5px',
  border: '1px solid transparent',
  cursor: 'pointer',
  color: 'white',
  transition: 'all 0.3s ease',
  userSelect: 'none',
  '&:hover': {
    borderColor: '#e0e0e0',
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
  '&[aria-disabled="true"]': {
    cursor: 'default',
    opacity: 0.7,
    pointerEvents: 'none',
  },
};

/** Light-surface trigger for page content (white backgrounds). */
export const HEADER_DROPDOWN_LIGHT_TRIGGER_SX: SystemStyleObject<Theme> = {
  color: 'text.primary',
  border: '1px solid',
  borderColor: 'rgba(0, 0, 0, 0.23)',
  backgroundColor: 'background.paper',
  '&:hover': {
    borderColor: 'text.primary',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
};

export const HEADER_DROPDOWN_MENU_ITEM_SX: SystemStyleObject<Theme> = {
  gap: 1.5,
  py: 1.2,
  px: 2,
  fontSize: '0.875rem',
  fontWeight: 500,
  borderRadius: 2,
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
};

export const HEADER_DROPDOWN_ANCHOR_ORIGIN = {
  vertical: 'bottom' as const,
  horizontal: 'right' as const,
};

export const HEADER_DROPDOWN_TRANSFORM_ORIGIN = {
  vertical: 'top' as const,
  horizontal: 'right' as const,
};
